import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Container from "../components/Container";
import Meta from "../components/Meta";

const ShippingPolicy = () => {
  return (
    <>
      <Container class1="policy-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="policy">
              <h1>Shipping & Delivery</h1>

              <p>
                For International buyers, orders are shipped and delivered through
                registered international courier companies and/or International speed
                post only. For domestic buyers, orders are shipped through registered
                domestic courier companies and/or speed post only. Orders are shipped
                within 0-7 days or as per the delivery date agreed at the time of
                order confirmation and delivering of the shipment subject to Courier
                Company / post office norms.{" "}
                <strong>ASTRAPE. AI PRIVATE LIMITED</strong> is not liable for any
                delay in delivery by the courier company / postal authorities and only
                guarantees to hand over the consignment to the courier company or
                postal authorities within 0-7 days from the date of the order and
                payment or as per the delivery date agreed at the time of order
                confirmation.
              </p>

              <p>
                Delivery of all orders will be to the address provided by the buyer.
                Delivery of our services will be confirmed on your mail ID as
                specified during registration. For any issues in utilizing our
                services you may contact our helpdesk on{" "}
                <a href="tel:9920310964">9920310964</a> or{" "}
                <a href="mailto:info@astrape.co.in">info@astrape.co.in</a>.
              </p>

              <p>
                <strong>Disclaimer:</strong> The above content is created at ASTRAPE.
                AI PRIVATE LIMITED&apos;s sole discretion. Razorpay shall not be
                liable for any content provided here and shall not be responsible for
                any claims and liability that may arise due to merchant’s
                non-adherence to it.
              </p>

              <p>
                <a href="/">Back to Home</a>
              </p>

              <footer className="mt-4">
                <p>© 2025 Astrape.AI Pvt Ltd | All rights reserved</p>
                <p>
                  <a href="/cancellation-refund" className="policy">
                    Cancellation & Refund
                  </a>{" "}
                  |{" "}
                  <a href="/terms-and-conditions" className="policy">
                    Terms & Conditions
                  </a>{" "}
                  |{" "}
                  <a href="/shipping-delivery" className="policy">
                    Shipping & Delivery
                  </a>{" "}
                  |{" "}
                  <a href="/privacy" className="policy">
                    Privacy
                  </a>
                </p>
              </footer>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ShippingPolicy;
